import {useEffect, useRef, useState} from 'react'

import {useNavigate} from 'react-router-dom'

import {checkUndefined, clearText, isEmpty} from 'react-lf-tools'

import {getDatabase, onValue, ref} from 'firebase/database'

import app from '../../services/firebase.js'

import moment from 'moment'

import {deleteOrder, getDiscountCoupon, getLastMenu, getLog, getMenu, sendLog} from '../../services/Apis.jsx'

import {
    clearLocal,
    clearSession,
    getLocal,
    getSession, removeLocal,
    removeSession,
    setLocal, setSession
} from '../../hooks/useStorage/useStorage.jsx'

import {
    colors,
    convertSearch,
    findProductByName,
    findProductBySku, fixEncoding, getMode,
    linkMenu,
    log,
    smoothScrolling
} from '../../utils/utils.jsx'

import Header from '../../components/header/Header.jsx'
import Carousel from './banners/Banners.jsx'
import Information from './information/Information.jsx'
import Loading from './loading/Loading.jsx'
import Categorys from './categorys/Categorys.jsx'
import Highlights from './highlights/Highlights.jsx'
import ListProducts from './listProducts/ListProducts.jsx'
import MenuDrawer from './menuDrawer/MenuDrawer.jsx'
import CartButton from './cartButton/CartButton.jsx'
import TrackOrder from './trackOrder/TrackOrder.jsx'
import InfoStore from './infoStore/InfoStore.jsx'

import {Snackbar} from '@mui/material'

import {
    DialogConfirmation,
    DialogCoupon,
    DialogErrorOrCancellation,
    DialogHistory,
    DialogLanguage,
    DialogLoading,
    DialogMyOrder,
    DialogProfile,
    DialogSendingSuccess,
    DialogTable,
    DialogWarning
} from '../../components/dialogs/Dialogs.jsx'

import {HomeContext} from '../../context/HomeContext.jsx'
import {general as textsGeneral, shoppingCart as textsShoppingCart} from '../../translate/Translate.jsx'
import {motion} from 'framer-motion'

import {ThemeProvider} from '@mui/material/styles'
import themeMui from '../../themeMui.jsx'

import './home.scss'

const Home = () => {
    const navigate = useNavigate()
    const slowLoading = (getLocal('menuSize', 0) > 500000)
    const [listSearch, setListSearch] = useState([])
    let [indexSearch, setIndexSearch] = useState(0)
    const [dialogConfirm, setDialogConfirm] = useState({
        open: false,
        title: '',
        message: ''
    })
    const [dialogWarning, setDialogWarning] = useState({
        open: false,
        title: '',
        message: ''
    })
    const [dialogCoupon, setDialogCoupon] = useState({
        open: false,
        coupon: '',
        message: ''
    })
    const [dialogSendingSuccess, setDialogSendingSuccess] = useState({
        open: false
    })
    const [dialogErrorOrCancellation, setDialogErrorOrCancellation] = useState({
        open: false,
        message: '',
        title: ''
    })
    const [dialogHistory, setDialogHistory] = useState({
        open: false
    })
    const [dialogLoading, setDialogLoading] = useState({
        open: false,
        message: ''
    })
    const [dialogMyOrder, setDialogMyOrder] = useState({
        open: false,
        order: {}
    })
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: ''
    })
    const [dialogProfile, setDialogProfile] = useState({
        open: false
    })
    const [dialogTable, setDialogTable] = useState({
        open: false
    })
    const [styles, setStyles] = useState({
        primaryColor: '#ffffff',
        secundaryColor: '#c22629',
        bodyColor: '#ffffff',
        textBodyColor: '#484848'
    })
    const [isLoading, setIsLoading] = useState(true)
    const [isCartButton, setIsCartButton] = useState(false)
    const [openDialogLanguage, setOpenDialogLanguage] = useState(false)
    const [openDrawer, setOpenDrawer] = useState(false)
    const [openLoading, setOpenLoading] = useState(false)
    const [banners, setBanners] = useState([])
    const [categorys, setCategorys] = useState([])
    const [groups, setGroups] = useState([])
    const [idGroup, setIdGroup] = useState('')
    const [highlights, setHighlights] = useState([])
    const [listProducts, setListProducts] = useState([])
    const [status, setStatus] = useState({})
    const [infoStore, setInfoStore] = useState({
        openStore: true
    })
    const [isRender, setRender] = useState(false)
    const _ref = useRef()

    const init = () => {
        checkIsGetMenu().then((isGetMenu) => {
            if (isGetMenu) {
                setOpenLoading(true)
                getMenu().then((response) => {
                    modeDebug(response)
                    setLocal('data', response, false)
                    setOpenLoading(false)
                    loadData(response)
                }).catch(error => {
                    console.error(error)
                })
            }
        })
        const data = getLocal('data')
        loadData(data)
    }

    const modeDebug = (response) => {
        try {
            if (!response.sucesso && response.sucesso !== undefined) {
                alert(`${response.mensagem}\nauthkey: ${import.meta.env.VITE_AUTHKEY}\nid: ${import.meta.env.VITE_ID_STORE}\nindex: ${import.meta.env.VITE_INDEX_STORE}\nvers�o: ${import.meta.env.VITE_VERSION_NAME}\n\nAtualize o card�pio ou verifique as cred�ncias`)
            }
        } catch (e) {

        }
    }

    const checkIsGetMenu = async () => {
        const lastMenuRemoto = await getLastMenu()
        const lastMenuLocal = getLocal('lastMenu')
        if (lastMenuRemoto !== lastMenuLocal) {
            if (fixEncoding(lastMenuRemoto) !== 'Arquivo não encontrado')
                setLocal('lastMenu', lastMenuRemoto)
            return true
        }
        return false
    }

    const loadData = (data) => {
        if (isEmpty(data)) return
        carousel(data)
        saveData(data)
        checkPayments(data)
        menuItems(data)
        coupon(data)
        setColor(data)
        checkMode(data)
    }

    const checkMode = (data) => {
        try {
            const allowOrdersLink = getSession('allowOrdersLink') || null
            if (!allowOrdersLink) {
                setSession('allowOrder', data.allowOrder)
            }
        } catch (e) {

        }
        if (getMode() !== data.mode)
            console.log(textsGeneral.differentOperationMode)

        const mode = (data.mode === 'mesa') ? 'table' : (data.mode === 'comanda') ? 'card' : 'desk'

        setSession('mode', mode)
    }

    const carousel = (data) => setBanners(!isEmpty(data.frontImage) ? data.frontImage : [])

    const saveData = (data) => {
        const openStore = true
        setInfoStore({openStore})
        setSession('openStore', openStore)
        const info = checkUndefined(data.info, {})
        setLocal('info', info)
        const infoAddress = checkUndefined(info.address, '')
        setLocal('infoAddress', infoAddress)
        const latitude = checkUndefined(info.latitude, 0)
        setLocal('latitude', latitude)
        const longitude = checkUndefined(info.longitude, 0)
        setLocal('longitude', longitude)
        const showOptionTakeAway = checkUndefined(data?.showOptionTakeAway, false)
        setLocal('showOptionTakeAway', showOptionTakeAway)
        if (!showOptionTakeAway) removeSession('eatHere')
        const identifyTableManually = checkUndefined(data.identifyTableManually, false)
        setLocal('identifyTableManually', identifyTableManually)
        /*const gularisToken = checkUndefined(data.gularisToken, '')
        setLocal('gularisToken', gularisToken)
        const gularisMinimum = checkUndefined(data.gularisMinimum, 0)
        setLocal('gularisMinimum', gularisMinimum)
        const gularisUrl = checkUndefined(data.gularisUrl, '')
        setLocal('gularisUrl', gularisUrl)*/
    }

    const checkPayments = (data) => {
        try {
            const pix = data.paymentTypes.some(item => item.code === "PIX")
            const onlinePayments = data.paymentTypes.some(item => item.code !== 'PIX' && item.online === "True")
            setLocal('paymentTypes', data?.paymentTypes || [])
            setLocal('pix', pix)
            setLocal('onlinePayments', onlinePayments)
        } catch (e) {

        }
    }

    const menuItems = (data) => {
        const menu = data.menu
        try {
            const size = JSON.stringify(data.menu).length
            setLocal('menuSize', size)
        } catch (e) {
            console.error(e.message)
        }
        if (isEmpty(menu)) return
        const categorys = [], menuItems = []
        menu.forEach(m => {
            let visibility = false
            const prod = m.products.filter(product => product.visibility.includes('DIGITALMENU'))
            if (Array.isArray(prod)) prod.forEach(product => product.variations.forEach((variation, index) => {
                variation.stepIndex = index
                variation.step = variation?.step || 0
            }))
            m.products = prod
            menuItems.push(m)
            categorys.push(m.category)
            prod.forEach(p => (visibility = (p.visibility.includes('DIGITALMENU'))))
            if (!visibility) {
                const indexMenuItems = ((menuItems.length) - 1)
                menuItems.splice(indexMenuItems, 1)
                const indexCategorys = ((categorys.length) - 1)
                categorys.splice(indexCategorys, 1)
            }
        })
        setCategorys(categorys)
        if (menuItems[0].category === 'Destaques') {
            const [{products}] = menu.filter(item => (item.category === 'Destaques'))
            setHighlights(products)
        }
        /*lista de produtos*/
        if (menuItems[0].category === 'Destaques') menuItems.shift()
        setListProducts(menuItems)
        setLocal('menuItems', menuItems)
    }

    const coupon = (data) => {
        if (!!data.popup) {
            const {msg, coupon, time} = data.popup
            const c = getLocal(`coupon-${coupon}`, '')
            if (!c) setTimeout(() => setDialogCoupon({
                open: true,
                coupon: coupon,
                message: msg
            }), (time * 1000))
        }
    }

    const links = () => {
        const search = convertSearch(location.search)
        setLocal('search', JSON.stringify(search))
        if (!search) return
        const mode = (!!search.mesa) ? (!!search.balcao) ? 'desk' : 'table' : 'card'
        //checkModeOperation(mode)
        const sector = (!!search.setor) ? search.setor : ''

        if (typeof search.allowOrder === 'string') {
            try {
                const allowOrder = JSON.parse(search.allowOrder)
                setSession('allowOrder', allowOrder)
                setSession('allowOrdersLink', 'ok')
            } catch (error) {
                console.error('Erro ao fazer parse do allowOrder:', error)
            }
        } else {
            removeSession('allowOrdersLink')
        }

        setSession('sector', sector)
        setSession('mode', mode)
        setLocal('authkey', search?.authkey)
        setLocal('idStore', search?.id)
        setLocal('indexStore', search?.index)
        if (mode === 'table') {
            setSession('table', search.mesa)
        } else if (mode === 'card') {
            const card = getSession('card', '')
            if (!card) setSession('card', search.cartao)
        }
    }

    const checkModeOperation = (currentMode) => {
        const mode = getSession('mode', '')
        if (!mode) return
        if (mode !== currentMode) {
            clearSession()
            clearLocal()
            window.location.reload()
        }
    }

    const handleSearch = value => {
        const s = findProductByName(value)
        if (s !== null) {
            smoothScrolling(s.product, 10)
        }
    }

    const handleClickMenu = () => setOpenDrawer(!openDrawer)

    const handleClickItemMenu = (item) => {
        switch (item) {
            case 'profile':
                setDialogProfile({open: true})
                setOpenDrawer(false)
                break
            case 'orderHistory':
                setDialogHistory({open: true})
                break
            case 'language':
                setOpenDialogLanguage(true)
                setOpenDrawer(false)
                break
            case 'clearData':
                setDialogConfirm({
                    open: true,
                    title: textsGeneral.confirmation,
                    message: textsGeneral.messageClearData,
                    type: 'clearData'
                })
                setOpenDrawer(false)
                break
            default:

        }
    }

    const handleClickInformation = (type) => {
        switch (type) {
            case 'table':
                const mode = getSession('mode', '')
                if (!mode || mode === 'table') return
                setDialogTable({open: true})
                break
            case 'consultation':
                navigate('/consulta')
                break
        }
    }

    const handleCloseDialogLanguage = () => setOpenDialogLanguage(false)

    const handleCloseDialogConfirmation = () => setDialogConfirm({...dialogConfirm, open: false})

    const handleClickDialogConfirm = (type) => {
        switch (type) {
            case 'clearData':
                clearLocal()
                clearSession()
                window.location.reload()
                break
            default:
                handleCloseDialogConfirmation()
                break
        }
    }

    const handleClickDialogWarning = () => setDialogWarning({...dialogWarning, open: false})

    const handleClickDialogCoupon = async (coupon) => {
        try {
            setDialogCoupon({...dialogCoupon, open: false})
            setDialogLoading({open: true, message: textsShoppingCart.checkingDiscountCoupon})
            const response = await getDiscountCoupon(coupon)
            setDialogLoading({open: false, message: ''})
            if (response.sucesso) {
                if (response.tipo_desconto === 'FREE_PRODUCT') {
                    const product = findProductBySku({sku: response.valor})
                    if (!product) return setDialogWarning({
                        open: true,
                        message: textsShoppingCart.productNotFound
                    })
                    const couponData = {
                        type: response.tipo_desconto,
                        discountCoupon: coupon,
                        minimum_purchase: parseFloat(response.compra_minima)
                    }
                    navigate('/sacola', {
                        state: {
                            product: product,
                            edit: false,
                            item: {},
                            isCouponProduct: true,
                            redeemCoupon: true,
                            couponData: couponData
                        }
                    })
                } else if (response.tipo_desconto === 'DELIVERY_FEE') {
                    setSession('discountCoupon', {
                        type: 'DELIVERY_FEE',
                        discountCoupon: coupon,
                        value: '',
                        minimum_purchase: parseFloat(response.compra_minima)
                    })
                } else if (response.tipo_desconto === 'VALUE') {
                    setSession('discountCoupon', {
                        type: 'VALUE',
                        discountCoupon: coupon,
                        value: parseFloat(response.valor),
                        minimum_purchase: parseFloat(response.compra_minima)
                    })
                } else if (response.tipo_desconto === 'PERCENTAGE') {
                    setSession('discountCoupon', {
                        type: 'PERCENTAGE',
                        discountCoupon: coupon,
                        minimum_purchase: parseFloat(response.compra_minima),
                        max_discount: parseFloat(response.desconto_max),
                        percentage: parseFloat(response.valor)
                    })
                }
            } else {
                setDialogWarning({
                    open: true,
                    message: response.mensagem
                })
            }
            setLocal(`coupon-${coupon}`, 'ok')
        } catch (e) {

        }
    }

    const handleCloseDialogCoupon = () => setDialogCoupon({...dialogCoupon, open: false})

    const handleClickDialogErrorOrCancellation = async () => {
        setDialogErrorOrCancellation({...dialogErrorOrCancellation, open: false})
        removePendingOrder()
        closeStatus()
    }

    const removePendingOrder = async () => {
        try {
            const orderOld = getLocal('orderOld', null)
            if (!!orderOld) {
                setDialogLoading({open: true, message: textsGeneral.cancelingOrder})
                const responseDeleteOrder = await deleteOrder(orderOld.chave)
                if (responseDeleteOrder.returnCode === 1) {
                    const responseGetLog = await getLog(orderOld.id_pedido)
                    if ((responseGetLog.returnCode === 1 && (responseGetLog.data.pedido.retorno.status === 'PENDENTE'))) {
                        setDialogLoading({open: true, message: textsGeneral.reassemblingCart})
                        const request = requestCancelOrder(orderOld)
                        const responseSendLog = await sendLog(request, 'PUT')
                        if (responseSendLog.returnCode === 1) {
                            const itemsOld = getSession('itemsOld', [])
                            if (!!itemsOld) {
                                setLocal('items', itemsOld)
                                checkItems()
                            }
                        }
                    } else {
                        window.location.reload()
                    }
                }
            }
        } finally {
            setDialogLoading({...dialogLoading, open: false})
        }
    }

    const requestCancelOrder = (orderOld) => JSON.stringify({
        pedido: {
            authkey: authkey,
            id_pedido: orderOld.id_pedido,
            retorno: {
                status: 'CANCELADO',
                mensagem: 'Pedido cancelado!'
            }
        }
    })

    const handleCloseDialogHistory = () => setDialogHistory({open: false})

    const handleClickDialogHistory = order => {
        setDialogHistory({...dialogHistory, open: false})
        setDialogMyOrder({open: true, order: order})
    }

    const handleCloseDialogMyOrder = () => setDialogMyOrder({...dialogMyOrder, open: false})

    const handleCloseProfile = () => setDialogProfile({open: false})

    const handleClickProfile = (profile) => {
        setDialogProfile({open: false})
        setLocal('profile', profile)
    }

    const handleCloseTable = () => setDialogTable({open: false})

    const handleClickTable = (table) => {
        setSession('table', table)
        setSession('tableOld', table)
        handleCloseTable()
    }

    const handleCloseSnackbar = () => setSnackbar({...snackbar, open: false})

    const handleClickDialogSendingSuccess = () => {
        removeLocal('orderOld')
        setDialogSendingSuccess({
            open: false
        })
    }

    const handleClickCartButton = () => {
        if (infoStore.openStore) {
            navigate('/carrinho')
        } else {
            setDialogWarning({
                open: true,
                title: textsGeneral.warning,
                message: textsGeneral.closedStore
            })
        }
    }

    const handleClickTrackOrder = (order) => setDialogMyOrder({
        open: true,
        order: order
    })

    const handleMessage = (message) => setSnackbar({
        open: true,
        message: message
    })

    useEffect(() => {
        links()
        init()
        checkItems()
        waitsForRendering()
        setTimeout(() => positionPage(), 50)
        checkOrderTime()
        checkOrderDispatched()
        linkMenu()
    }, [])

    const checkItems = () => {
        const items = getLocal('items', [])
        setIsCartButton((!!items.length))
    }

    const waitsForRendering = () => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setRender(entry.isIntersecting)
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 1.0
            }
        )
        if (_ref.current) observer.observe(_ref.current)
        return () => {
            if (_ref.current) observer.unobserve(_ref.current)
        }
    }

    const positionPage = () => {
        const positionPage = getSession('positionPage')
        if (!isEmpty(positionPage)) {
            window.scrollTo(0, positionPage)
            removeSession('positionPage')
        }
    }

    const checkOrderTime = () => {
        const order = getLocal('orderOld', {})
        if (!isEmpty(order)) {
            const currentTime = moment()
            const expirationTime = moment(order.dataHora, 'YYYY-MM-DD HH:mm:ss').add(2, 'hours')
            if (expirationTime.isBefore(currentTime)) closeStatus()
        }
    }

    const closeStatus = () => {
        removeLocal('orderOld')
        setStatus({})
    }

    const checkOrderDispatched = () => {
        const order = getLocal('orderOld', {})
        const authkey = getLocal('authkey')
        const mode = getSession('mode')
        if (!isEmpty(order)) {
            const starCountRef = ref(getDatabase(app), `logs/${authkey}/${order.id_pedido}/pedido/retorno`)
            onValue(starCountRef, (snapshot) => {
                const data = snapshot.val()
                log(data, 'table')
                if (!data.status) return
                if (data.status === 'PENDENTE') {
                    setDialogLoading({
                        open: true,
                        message: textsGeneral.waitingConfirmation
                    })
                    const timeoutIdOrder = setTimeout(() => {
                        setDialogLoading({...dialogLoading, open: false})
                        setDialogErrorOrCancellation({
                            open: true,
                            message: textsGeneral.orderNotConfirmed,
                            title: textsGeneral.cancelOrder
                        })
                    }, 30000)
                    setSession('timeoutIdOrder', timeoutIdOrder)
                    return
                }
                if (data.status === 'CONFIRMADO') {
                    if (!!data?.qrcode) {
                        setDialogLoading({...dialogLoading, open: false})
                        setStatus(data)
                        const timeoutIdOrder = getSession('timeoutIdOrder', 0)
                        if (!!timeoutIdOrder) clearTimeout(timeoutIdOrder)
                        return
                    }
                    if ((mode === 'desk') && !!data?.identificacao) {
                        setDialogLoading({...dialogLoading, open: false})
                        setStatus(data)
                        const timeoutIdOrder = getSession('timeoutIdOrder', 0)
                        if (!!timeoutIdOrder) clearTimeout(timeoutIdOrder)
                        return
                    }
                    const timeoutIdOrder = getSession('timeoutIdOrder', 0)
                    if (!!timeoutIdOrder) clearTimeout(timeoutIdOrder)
                    setDialogLoading({...dialogLoading, open: false})
                    setDialogErrorOrCancellation({...dialogErrorOrCancellation, open: false})
                    setDialogSendingSuccess({open: true})
                    setStatus({})
                    removeLocal('orderOld')
                    return
                }
                if (data.status === 'ERRO') {
                    const timeoutIdOrder = getSession('timeoutIdOrder', 0)
                    if (!!timeoutIdOrder) clearTimeout(timeoutIdOrder)
                    setDialogLoading({...dialogLoading, open: false})
                    setDialogErrorOrCancellation({
                        open: true, message:
                        data.mensagem,
                        title: textsGeneral.cancelOrder
                    })
                    setStatus({})
                } else {
                    setStatus(data)
                }
                updateStatusOrder(data, order)
            })
        }
    }

    const updateStatusOrder = (status, order) => {
        const orderOld = getLocal('orderOld', {})
        const history = getLocal('history', [])
        const index = history.findIndex((h) => (h.id_pedido === order.id_pedido))
        const _return = {
            status: status.status,
            message: status.mensagem
        }
        history[index].retorno = _return
        orderOld.retorno = _return
        setLocal('orderOld', orderOld)
        setLocal('history', history)
    }

    useEffect(() => {
        if (isRender) listGroups()
    }, [isRender])

    const listGroups = () => {
        const groups = []
        categorys.forEach(i => {
            const id = '#item-' + clearText(i)
            const elem = document.querySelector(id)
            if (elem !== null) {
                const coordenadas = elem.getBoundingClientRect()
                groups.push({id: id, position: coordenadas.width})
            }
        })
        setGroups(groups)
    }

    const setColor = ({colorStore}) => {
        const primaryColor = `#${colorStore?.body}`
        const secundaryColor = `#${colorStore?.nextButton}`
        const bodyColor = primaryColor
        const textBodyColor = `#${colorStore?.fontBody}`
        const cardProduct = `#${colorStore?.cardProduct}`
        const titleColor = `#${colorStore?.title}`
        const descriptionColor = `#${colorStore?.description}`
        const priceColor = `#${colorStore?.price}`
        const buttonColor = `#${colorStore?.nextButton}`
        const textButtonColor = `#${colorStore?.fontButton}`
        const toolbarColor = `#${colorStore?.toolbar}`
        const textToolbarColor = `#${colorStore?.fontToolbar}`
        setLocal('colors', {
            primaryColor,
            secundaryColor,
            bodyColor,
            textBodyColor,
            cardProduct,
            titleColor,
            descriptionColor,
            priceColor,
            buttonColor,
            textButtonColor,
            toolbarColor,
            textToolbarColor
        })
        setStyles({primaryColor, secundaryColor, bodyColor, textBodyColor})
    }

    colors(document)

    window.addEventListener('beforeinstallprompt', (event) => {
        event.preventDefault()
        console.log('Prompt de instalação bloqueado.')
    })

    return <ThemeProvider theme={themeMui(styles)}>
        <motion.div
            className={'home'}
            ref={_ref}
            initial={{x: -400}}
            animate={{x: 0}}
            transition={{duration: 0.3}}>
            <Header
                home={true}
                title={import.meta.env.VITE_SHORT_NAME}
                buttonMenu={true}
                buttonSearch={true}
                onClick={handleClickMenu}
                onChange={handleSearch}
            />
            <MenuDrawer
                openDrawer={openDrawer}
                onClick={handleClickItemMenu}
                onClose={handleClickMenu}/>
            <div className={'container-home'}>
                <Carousel images={banners}/>
                <Information
                    infoStore={infoStore}
                    onClick={handleClickInformation}
                />
                <Loading open={openLoading}/>
                <HomeContext.Provider value={{categorys, groups, setIdGroup, setRender, isCartButton}}>
                    <Categorys categorys={categorys} idGroup={idGroup}/>
                    <Highlights highlights={highlights}/>
                    <ListProducts listProducts={listProducts}/>
                    <InfoStore/>
                    {(isCartButton) && <CartButton
                        isCartButton={isCartButton}
                        onClick={handleClickCartButton}/>}
                    <TrackOrder
                        infoStore={infoStore}
                        status={status}
                        onClick={handleClickTrackOrder}
                        onMessage={handleMessage}
                    />
                </HomeContext.Provider>
            </div>
            <>
                <DialogLanguage
                    open={openDialogLanguage}
                    onClose={handleCloseDialogLanguage}
                />
                <DialogLoading
                    open={dialogLoading.open}
                    message={dialogLoading.message}
                />
                <DialogConfirmation
                    open={dialogConfirm.open}
                    title={dialogConfirm.title}
                    message={dialogConfirm.message}
                    type={dialogConfirm.type}
                    onClick={handleClickDialogConfirm}
                    onClose={handleCloseDialogConfirmation}
                />
                <DialogWarning
                    open={dialogWarning.open}
                    title={dialogWarning.title}
                    message={dialogWarning.message}
                    noButton={dialogWarning.noButton}
                    onClick={handleClickDialogWarning}
                />
                <DialogCoupon
                    open={dialogCoupon.open}
                    message={dialogCoupon.message}
                    coupon={dialogCoupon.coupon}
                    onClick={handleClickDialogCoupon}
                    onClose={handleCloseDialogCoupon}
                />
                <DialogErrorOrCancellation
                    open={dialogErrorOrCancellation.open}
                    message={dialogErrorOrCancellation.message}
                    title={dialogErrorOrCancellation.title}
                    onClick={handleClickDialogErrorOrCancellation}
                />
                <DialogHistory
                    open={dialogHistory.open}
                    onClose={handleCloseDialogHistory}
                    onClick={handleClickDialogHistory}
                />
                <DialogMyOrder
                    open={dialogMyOrder.open}
                    order={dialogMyOrder.order}
                    onClose={handleCloseDialogMyOrder}
                />
                {(dialogProfile.open) && <DialogProfile
                    open={dialogProfile.open}
                    onMessage={handleMessage}
                    onClose={handleCloseProfile}
                    onClick={handleClickProfile}
                />}
                <DialogTable
                    open={dialogTable.open}
                    onClose={handleCloseTable}
                    onClick={handleClickTable}
                />
                {(dialogSendingSuccess.open) && <DialogSendingSuccess
                    open={dialogSendingSuccess.open}
                    onClick={handleClickDialogSendingSuccess}
                />}
            </>
            <>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={1600}
                    onClose={handleCloseSnackbar}
                    message={snackbar.message}/>
            </>
        </motion.div>
    </ThemeProvider>
}

export default Home
